import { createContext, type ReactNode, useContext } from "react";
import { type Catalog, type CatalogState, useLoadCatalog } from "./catalog";

const Ctx = createContext<CatalogState | null>(null);
let latest: Catalog | null = null;

/** Mounted once in the authenticated layout so every view shares one catalog instance. */
export function CatalogProvider({ children }: { children: ReactNode }) {
  const state = useLoadCatalog();
  latest = state.catalog;
  return <Ctx.Provider value={state}>{children}</Ctx.Provider>;
}

export function useCatalogState(): CatalogState {
  const v = useContext(Ctx);
  if (!v) throw new Error("useCatalog outside CatalogProvider");
  return v;
}

export function useCatalog(): Catalog {
  return useCatalogState().catalog;
}

/** The catalog for non-React code (commands, mutations). Null before the app layout mounted. */
export function getCatalog(): Catalog | null {
  return latest;
}
